import * as React from "react";
import * as ReactMarkdown from "react-markdown";
import { descriptionList } from "./plugins";
import { renderers } from "./renderers";

type MDProps = ReactMarkdown.ReactMarkdownProps;

/**
 * For parsing Markdown into HTML. Created as a way to potentially deliver
 * flexible 'informational/rhetorical' content within a QuestionSet.
 */
const Markdown: React.FC<MDProps> = (props) => (
  <ReactMarkdown renderers={renderers} plugins={[descriptionList]} {...props} />
);

export { Markdown };
